import React, {Component} from 'react';
import '../css/Modal.css';
import {connect} from 'react-redux';

import closeButtonBlack from '../assets/closeButton.svg';
import closeButtonWhite from '../assets/closeButtonWhite.svg';


class Modal extends Component {

  static defaultProps = {
    animation: 'fade',
    open: false,
    includeBackdrop: true,
    showCloseButton: true,
    overflow: 'auto',
    closeButtonColor: 'black',
    closeTimeoutDuration: 800,
  }

  state = {
    open: false,
  }

  componentWillReceiveProps(nextProps) {
    const {open} = this.props;
    if (!open && nextProps.open) {
      this.setState({open: true});
      document.addEventListener('keydown', this.handleKeyDown, false);
    }
    else if (open && !nextProps.open) {
      this.handleClose();
    }
  }

  componentDidMount() {
    const {open} = this.state;
    if (!open && this.props.open) {
      this.setState({open: true});
      document.addEventListener('keydown', this.handleKeyDown, false);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, false);
  }

  componentDidUpdate(prevProps, prevState) {
    const {includeBackdrop, animation} = this.props;
    const {open} = this.state;
    if (open && !prevState.open) {
      if (includeBackdrop) {
        this.backdrop.className = 'Modal-backdrop-open';
      }
      if (animation === 'down') {
        this.modal.className = 'Modal-expand-from-top';
      }
      else {
        this.modal.className = 'Modal-up';
      }
      
    }
  }

  handleClose = () => {
    const {
      includeBackdrop,
      closeTimeoutDuration,
      animation,
    } = this.props;
    if (this.modal) {
      if (includeBackdrop) {
        this.backdrop.className = 'Modal-backdrop-closed';
      }
      if (animation === 'down') {
        this.modal.className = 'Modal-contract-from-bottom';
      }
      else {
        this.modal.className = 'Modal-down';
      }
    }
    document.removeEventListener('keydown', this.handleKeyDown, false);
    setTimeout(() => {
      this.setState({open: false})
    }, closeTimeoutDuration)
  }

  handleClickOutside = (event) => {
    const {
      closeOnOverlayClick,
      onClose,
    } = this.props;

    if (!(this.state.open && this.props.open)) {
      return;
    }

    const {target} = event;
    const {backdrop, modal} = this;
    if (backdrop.contains(target) && !modal.contains(target)) {
      if (closeOnOverlayClick) {
        onClose();
      }
    }
  }

  handleCloseButtonClick = () => {
    const {onClose} = this.props;
    if (onClose) {
      onClose();
    }
  }

  handleKeyDown = (event) => {
    const {onClose} = this.props;
    if (event.keyCode === 27) {
      onClose();
    }
  }

  renderModal() {
    const {
      fullScreen,
      showCloseButton,
      overflow,
      topLeft,
      style,
      closeButtonStyle,
      backdropStyle,
      bodyStyle,
      closeButtonColor,
      headerStyle,
    } = this.props;

    let closeButton = closeButtonColor === 'white'
      ? closeButtonWhite
      : closeButtonBlack;

    const s = {
      backdrop: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: '99',
        //display: open ? 'flex' : 'none',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
      },
      modal: {
        backgroundColor: 'white',
        maxWidth: '500px',
        margin: '0 auto',
        overflow,
        //border: 'solid red',
      },
      header: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '10px',
        //border: 'solid blue',
      },
      closeButtonContainer: {

      },
      closeButton: {
        width: '20px',
        heigth: '20px',
        //border: 'solid green',
      },
      body: {
        padding: '10px',
      },
    }

    if (fullScreen) {
      s.backdrop.padding = 0;
      s.modal.maxWidth = '100%';
      s.modal.width = '100%';
      s.modal.height = '100%';
    }

    if (backdropStyle) {
      s.backdrop = {...s.backdrop, ...backdropStyle}
    }

    if (topLeft) {
      s.header = {...s.header, justifyContent: 'space-between'};
    }

    if (style) {
      s.modal = {...s.modal, ...style};
    }

    if (closeButtonStyle) {
      s.closeButton = {...s.closeButton, ...closeButtonStyle};
    }

    if (bodyStyle) {
      s.body = {...s.body, ...bodyStyle}
    }

    if (headerStyle) {
      s.header = {...s.header, ...headerStyle}
    }

    return (
      <div 
        style={s.backdrop} 
        ref={el => this.backdrop = el}
        onClick={this.handleClickOutside}
      >
        <div 
          style={s.modal}
          ref={el => this.modal = el}
          className="Modal-initial"
        >

          <div style={s.header}>
            {topLeft}
            <div style={s.closeButtonContainer}>
            {showCloseButton &&
              <img
                style={s.closeButton}
                src={closeButton}
                alt="Close"
                className="hover-pointer"
                onClick={this.handleCloseButtonClick}
              />
            }
            </div>
          </div>

          <div style={s.body}>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {open} = this.state;
    if (!open) {return null};
    return (
      <div>
        {this.renderModal()}
      </div>
    )
  }
  
}



const mapStateToProps = (state, ownProps) => {
  return {

  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}


const Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(Modal)

export default Connected;



// WEBPACK FOOTER //
// ./src/main/Modal.js